import { apiRequest } from '../../../api/client';

export async function requestAdminPasswordReset({ email }) {
  try {
    const data = await apiRequest('/api/admin/auth/password-reset', {
      method: 'POST',
      body: { email: String(email || '').trim() },
    });
    if (!data?.success) {
      throw new Error(data?.error || 'Failed to send reset link');
    }
    return data;
  } catch (err) {
    if (err?.status >= 500) {
      throw new Error('Failed to send reset link. Please try again.');
    }
    throw err;
  }
}
